import React from 'react';

const EmptyState = ({ t }) => (
    <div className="empty-page">
        <img
            className="notification-img custom-img-fluid transaction-icon"
            src={'/assets/images/svg/empty-v4.svg'}
            alt={'No Data'}
        />
        <h3 className="d-block fw-normal dark-text text-center mt-3">
            {t('noTransaction')}.<p>{t('noTransactionsFound')}</p>
        </h3>
    </div>
);

export default EmptyState;
